// @ts-nocheck

import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaCirclePlus, FaCircleMinus } from "react-icons/fa6";
import { createAmenity } from "../../../features/amenity";

const AddAmenity = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "", // Amenity name
    description: "", // Single description string
    popular: false, // Popular flag
    is_more: false, // Flag for more info
    photo: null, // Image for the amenity
  });

  const [imagePreview, setImagePreview] = useState(null); // For image preview

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value, // Handle checkboxes
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0], // Handle photo image change
      }));
      setImagePreview(URL.createObjectURL(e.target.files[0])); // For image preview
    }
  };

  const handleSubmit = () => {
    // Dispatch createAmenity with formData
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(createAmenity(formDataFinal))
      .then((res) => {
        toast.success("Amenity created successfully!");
        navigate("/amenity"); // Redirect to amenities list or another page
      })
      .catch((err) => {
        console.log(err, "error");
        toast.error("An error occurred while creating the amenity.");
      });
  };

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
      mt={15}
    >
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Add Amenity
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="name"
              placeholder="Enter the amenity name"
              value={formData.name}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Description
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="description"
              placeholder="Enter the amenity description"
              value={formData.description}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Popular
              </SoftTypography>
            </SoftBox>
            <input
              type="checkbox"
              name="popular"
              checked={formData.popular}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Is More Info Available?
              </SoftTypography>
            </SoftBox>
            <input
              type="checkbox"
              name="is_more"
              checked={formData.is_more}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Photo
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept="image/*"
              name="photo"
              onChange={handleImageChange}
              style={{ width: "100%" }}
            />
            {imagePreview && (
              <img src={imagePreview} alt="Preview" style={{ width: "150px", height: "150px", marginTop: "20px" }} />
            )}
          </SoftBox>

          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddAmenity;
